













































import { Component, Vue } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import layout from '@/layouts/app-layout.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import { Permissions } from '@/models/permission-constants';

const UserModule = namespace('user');

@Component({
    components: {
        layout,
        breadcrumb,
    },
})
export default class Home extends Vue {
    @UserModule.Getter public canViewEnquiries: boolean;
    @UserModule.Getter public canCreateEnquiries: boolean;
    @UserModule.Getter public canViewQuotes: boolean;
    @UserModule.Getter public canViewApprovals: boolean;
    @UserModule.Getter public canViewOrders: boolean;
}
